import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import {
  CLIENT_ROUTES,
  INPUTS_PROPS,
  INVITATION_TYPE,
  UTRON_PLARFORMS,
} from "../../../../../enums/Enums";
import Strings from "../../../../../resources/Strings";
import {
  getErrorMessage,
  isEmail,
  isNameValid,
  isPhoneNumber,
  isRequired,
  isValidPassword,
} from "../../../../../utils/FormUtils";
import EllipseButton from "../../../Buttons/EllipseButton/EllipseButton";
import PasswordInput from "../../../Inputs/CustomInputs/PasswordInput";
import classes from "./SignUpGmtUserForm.module.css";
import * as actionsService from "../../../../../services/ActionsService/ActionsService";
import { useSelector } from "react-redux";
import TextInput from "../../../Inputs/CustomInputs/TextInput";
import VerificationPhoneInput from "../../../Inputs/CustomInputs/VerificationPhoneInput";
import UploadImageInput from "../../../Inputs/CustomInputs/UploadImageInput";
import { removePhoneNumberPrefix, getPhoneNumberDialingCodePrefix } from "../../../../../utils/CommonUtils";
import { CreateUserEntity } from "../../../../../entities/ServicesEntities/UserEntities/CreateUserEntity";
import { UtronUserEntity } from "../../../../../entities/ServicesEntities/UserEntities/UtronUserEntity";
import { showErrorMessage } from "../../../../../utils/MessagesUtils";
import { UserScopeEntity } from "../../../../../entities/ServicesEntities/UserEntities/UserScopeEntity";
import Icons from "../../../../../resources/icons/Icons";
import { RegisterChargeAccountEntity } from "../../../../../entities/ServicesEntities/UserEntities/RegisterChargeAccountEntity";
import PhoneInputWithoutVerification from "../../../Inputs/CustomInputs/PhoneInputWithoutVerification";

const SignUpGmtUserForm = (props) => {
  const isShowLoadingSpinner = useSelector(
    (state) => state.common.isShowLoadingSpinner
  );
  const isChargeAccount = props.invitationData.invitationType === INVITATION_TYPE.CHARGE_ACCOUNT; 
  //const chargeAccountData = isChargeAccount ? props?.invitationData.chargeAccountData : null;
  const [formData, setFormData] = useState({
    newPassword: "",
    repeatPassword: "",
    chargeAccountName: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    profilePicture: "",
    isPhoneVerified: false,
    isCurrentStepValid: false,
    isStepSubmitted: false,
  });
  const [errors, setErrors] = useState({});
  const [submitErrors, setSubmitErrors] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    const hasError = Object.values(errors).some((hasError) => hasError);
    handleCurrentStepValidity(hasError);
  }, [errors]);



  const handleError = (error) => {
    setErrors((prevState) => ({
      ...prevState,
      ...error,
    }));
  };

  const handleChange = (newProp) => {
    setSubmitErrors("");
    setFormData({ ...formData, ...newProp });
  };

  const handleCurrentStepValidity = (hasError) => {
    setFormData({ ...formData, isCurrentStepValid: !hasError });
  };

  const validateForm = () => {
    const passwordValidation = isValidPassword(
      formData.newPassword,
      formData.repeatPassword
    );
    if (!passwordValidation.isValid) {
      setSubmitErrors(passwordValidation.errorMessage);
    }
    handleError({
      [INPUTS_PROPS.NEW_PASSWORD]: !passwordValidation.isValid,
    });
    return passwordValidation.isValid;
  };

  const buildUtronUserObject = () => {
    const { firstName, lastName, profilePicture, exsistUserEntity } = formData;

    const utronUser = exsistUserEntity
      ? exsistUserEntity
      : new UtronUserEntity(0, "");

    utronUser.firstName = firstName;
    utronUser.lastName = lastName;
    utronUser.image = profilePicture?.split(",")[1];
    return utronUser;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    let userToCreate = {};
    setFormData({ ...formData, ["isStepSubmitted"]: true });
    const isValidForm = validateForm();
    if (isValidForm && formData.isCurrentStepValid) {
      const utronUser = buildUtronUserObject();
      const userScope = new UserScopeEntity(
        0,
        props?.invitationData?.scopeId,
        props?.invitationData?.roleId
      );
      //Platform
      const userPlatform = [UTRON_PLARFORMS.GMT];
      userToCreate = new CreateUserEntity(
        props?.invitationData?.phone,
        props?.invitationData?.email,
        0,
        0,
        userPlatform,
        [],
        utronUser,
        null,
        false,
        [userScope],
        formData?.newPassword
      );

      let action = null;
      if (!props?.invitationData?.isNewUser /*formData?.exsistUserEntity*/) {
        action = actionsService.registerExsistUser(userToCreate);
      } else {
        if (props?.invitationData?.invitationType === INVITATION_TYPE.GMT) {
          action = actionsService.createUser(userToCreate);
        }
        if (props?.invitationData?.invitationType === INVITATION_TYPE.CHARGE_ACCOUNT) {
          const registerChargeAccount = new RegisterChargeAccountEntity(userToCreate, props?.invitationData.chargeAccountData);
          action = actionsService.registerChargeAccountUser(registerChargeAccount);
        }
      }
      action?.then((response) => {
        if (response.data.isSuccess) {
          setSuccessMessage("Set up completed successfully!");
          setShowForm(false);
        } else {
          showErrorMessage(response.data?.error);
        }
      });
    }
  };

  const handleShowForm = () => {
    setShowForm(true);
  };

  return (
    <div className={classes.signUpForm}>
      {!showForm && !successMessage && (
        <div className={classes.signUpSetUp}>
          <div className={classes.title}>{Strings.SETUP_ACCOUNT}</div>
          <div className={classes.subTitle}>
            {Strings.SETUP_ACCOUNT_MESSAGE}
          </div>
          <div className={classes.signUpButton}>
            <EllipseButton onClick={handleShowForm}>
              {Strings.SETUP_ACCOUNT}
            </EllipseButton>
          </div>
          <div className={classes.message}>
            {Strings.RESET_PASSWORD_VALIDATION_MESSAGE}
          </div>
        </div>
      )}
      {showForm && !(formData.isStepSubmitted && successMessage) && (
        <>
          <div className={classes.title}>{Strings.SETUP_ACCOUNT}</div>

          <form name="SignUpGmtUserForm" onSubmit={handleSubmit}>
            <div className={classes.fileds}>
              {isChargeAccount && (
                <TextInput
                  disabled={true}
                  label={Strings.INPUT_LABELS.CHARGE_ACCOUNT_NAME}
                  id={INPUTS_PROPS.CHARGE_ACCOUNT_NAME}
                  value={
                    /*formData?.chargeAccountName*/ props?.invitationData
                      ?.chargeAccountData?.chargeAccountName
                  }
                  isStepSubmitted={formData?.isStepSubmitted}
                  // handleError={handleError}
                  onChange={handleChange}
                  // hasError={!isRequired(formData?.chargeAccountName).isValid} // data from invitation
                  // errorMessage={getErrorMessage(isRequired(formData?.chargeAccountName))}
                />
              )}
              <TextInput
                disabled={isChargeAccount}
                label={Strings.INPUT_LABELS.FIRST_NAME}
                id={INPUTS_PROPS.FIRST_NAME}
                value={
                  isChargeAccount
                    ? props?.invitationData?.chargeAccountData?.contactFirstName
                    : formData.firstName
                }
                onChange={handleChange}
                isStepSubmitted={formData.isStepSubmitted}
                handleError={handleError}
                hasError={
                  isChargeAccount
                    ? false
                    : !isRequired(formData.firstName).isValid ||
                      !isNameValid(formData.firstName).isValid
                }
                errorMessage={
                  getErrorMessage(isRequired(formData.firstName))
                    ? getErrorMessage(isRequired(formData.firstName))
                    : getErrorMessage(isNameValid(formData.firstName))
                }
              />
              <TextInput
                disabled={isChargeAccount}
                label={Strings.INPUT_LABELS.LAST_NAME}
                id={INPUTS_PROPS.LAST_NAME}
                value={
                  isChargeAccount
                    ? props?.invitationData?.chargeAccountData?.contactLastName
                    : formData.lastName
                }
                onChange={handleChange}
                isStepSubmitted={formData.isStepSubmitted}
                handleError={handleError}
                hasError={
                  isChargeAccount
                    ? false
                    : !isRequired(formData.lastName).isValid ||
                      !isNameValid(formData.lastName).isValid
                }
                errorMessage={
                  getErrorMessage(isRequired(formData.lastName))
                    ? getErrorMessage(isRequired(formData.lastName))
                    : getErrorMessage(isNameValid(formData.lastName))
                }
              />
              {isChargeAccount ? (
                <PhoneInputWithoutVerification
                  disabled={true}
                  label={Strings.INPUT_LABELS.PHONE_NUMBER}
                  id={INPUTS_PROPS.PHONE_NUMBER}
                  phoneVerifiedId={INPUTS_PROPS.PHONE_VERIFIED}
                  dialingCode={getPhoneNumberDialingCodePrefix(
                    props?.invitationData?.phone
                  )}
                  //isVerifyValidationNeeded={false}
                  value={removePhoneNumberPrefix(props?.invitationData?.phone)}
                  isEditMode={true} // props.isEditMode
                  //actionText={Strings.CONFIRM_VERIFY}
                  isPhoneVerified={formData.isPhoneVerified}
                  onChange={handleChange}
                  handleError={handleError}
                  isStepSubmitted={formData.isStepSubmitted}
                  // hasError={!isPhoneNumber(phoneNumberToSend(props?.invitationData?.phone)).isValid}
                  // errorMessage={getErrorMessage(
                  //   isPhoneNumber(phoneNumberToSend(props?.invitationData?.phone))
                  // )}
                  selectedSitesIds={props?.invitationData?.selectedSitesIds}
                  isGmtUserCreation={true}
                />
              ) : (
                <VerificationPhoneInput
                  disabled={true}
                  label={Strings.INPUT_LABELS.PHONE_NUMBER}
                  id={INPUTS_PROPS.PHONE_NUMBER}
                  phoneVerifiedId={INPUTS_PROPS.PHONE_VERIFIED}
                  dialingCode={getPhoneNumberDialingCodePrefix(
                    props?.invitationData?.phone
                  )}
                  value={removePhoneNumberPrefix(props?.invitationData?.phone)}
                  isEditMode={true} // props.isEditMode
                  actionText={Strings.CONFIRM_VERIFY}
                  isPhoneVerified={formData.isPhoneVerified}
                  onChange={handleChange}
                  handleError={handleError}
                  isStepSubmitted={formData.isStepSubmitted}
                  // hasError={!isPhoneNumber(phoneNumberToSend(props?.invitationData?.phone)).isValid}
                  // errorMessage={getErrorMessage(
                  //   isPhoneNumber(phoneNumberToSend(props?.invitationData?.phone))
                  // )}
                  selectedSitesIds={props?.invitationData?.selectedSitesIds}
                  isGmtUserCreation={true}
                />
              )}
              <TextInput
                disabled={true}
                label={Strings.INPUT_LABELS.EMAIL}
                id={INPUTS_PROPS.EMAIL}
                value={props?.invitationData?.email}
                isStepSubmitted={formData.isStepSubmitted}
                //handleError={handleError}
                onChange={handleChange}
                //hasError={!isEmail(props?.invitationData?.email).isValid}
                // errorMessage={getErrorMessage(
                //   isEmail(props?.invitationData?.email)
                // )}
              />
              <PasswordInput
                label={Strings.INPUT_LABELS.PASSWORD}
                id={INPUTS_PROPS.NEW_PASSWORD}
                value={formData.newPassword}
                onChange={handleChange}
                isStepSubmitted={formData.isStepSubmitted}
                handleError={handleError}
                hasError={!isRequired(formData.newPassword).isValid}
                errorMessage={getErrorMessage(isRequired(formData.newPassword))}
                showTooltip={true}
                tooltipTitle={Strings.TOOLTIP_INFO_TITLE.PASSWORD}
                tooltipText={Strings.TOOLTIP_INFO_TEXT.PASSWORD}
              />
              {formData.isStepSubmitted && submitErrors && (
                <div className={classes.error}>{submitErrors}</div>
              )}
              <PasswordInput
                label={Strings.INPUT_LABELS.REPEAT_PASSWORD}
                id={INPUTS_PROPS.REPEAT_PASSWORD}
                value={formData.repeatPassword}
                onChange={handleChange}
                isStepSubmitted={formData.isStepSubmitted}
                handleError={handleError}
                hasError={!isRequired(formData.repeatPassword).isValid}
                errorMessage={getErrorMessage(
                  isRequired(formData.repeatPassword)
                )}
              />
              <UploadImageInput
                id={INPUTS_PROPS.PROFILE_PICTURE}
                defaultValue={formData.profilePicture}
                onChange={handleChange}
                image={formData.profilePicture}
              />
            </div>

            <div className={classes.signUpButton}>
              <EllipseButton type="submit">
                {Strings.SAVE_NEW_PASSWORD}
              </EllipseButton>
            </div>
          </form>
        </>
      )}
      {/* {formData.isStepSubmitted && submitErrors && (
        <div className={classes.error}>{submitErrors}</div>
      )} */}

      {formData.isStepSubmitted && successMessage && (
        <div className={classes.signUpSetUp}>
          <img src={Icons.UPDATE_SUCCESS} />
          <div className={classes.title}>{Strings.SETUP_COMPLETED_TITLE}</div>
          <div className={classes.subTitle}>
            {Strings.SETUP_COMPLETED_SUB_TITLE}
          </div>
          <NavLink to={CLIENT_ROUTES.LOGIN}>
            <div className={classes.signUpButton}>
              <EllipseButton>{Strings.LOGIN}</EllipseButton>
            </div>
          </NavLink>
        </div>
      )}
    </div>
  );
};

export default SignUpGmtUserForm;
